export default function AuthGuard({ children }) {
  return <>{children}</>;
}
